export enum AssetTypeId {
    Dataset = 1,
    Result = 2,
    Model = 3,
}
